import React from 'react';
import {Col, Row, Card} from 'react-bootstrap';
import useData from 'utils/useData';
import CellLoader from '@/components/loading/CellLoader';  
import HelpTextBlock from '@/components/help_text/HelpTextBlock';
import i18n from 'i18n';

interface AdditionalAppChoice {
    value: string;
    label: string;
    url: string;
    description: string;
}

const AdditionalAppsSettingsView: React.FC = () => {
    const [additionalAppsChoices, loading] = useData<AdditionalAppChoice[]>(
        window.URLS.additionalAppsChoices, 
        'additionalAppsChoices'
    );


    if (loading) {
        return <CellLoader />;
    }

    return (
        <>

            <Row>
                <Col xs={12}>
                    <HelpTextBlock helpText={i18n.t('jt_additional_applications_description.text')} />
                </Col>
            </Row>

            {!additionalAppsChoices || additionalAppsChoices.length === 0 ? (
                <Row>
                    <Col xs={12}>
                        <div className="alert alert-info">
                            {i18n.t('jt_additional_apps.text')}
                        </div>
                    </Col>
                </Row>
            ) : (
                <Row>
                    {additionalAppsChoices.map((app) => (
                        <Col xs={12} md={6} lg={4} key={app.value} className="mb-4">
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column">
                                    <Card.Title>{app.label}</Card.Title>
                                    <Card.Text className="flex-grow-1">
                                        {app.description}
                                    </Card.Text>
                                    <a
                                        className="btn btn-primary btn-sm mt-auto"
                                        href={`${window.URLS.loginRedirectUrl}?application=${app.value}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {i18n.t('jt_open.text')}
                                    </a>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}
        </>
    );
};

export default AdditionalAppsSettingsView;
